module.exports = __webpack_public_path__ + "static/img/14.c287e78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/14.png
// module id = GsGD
// module chunks = 0